<mat-toolbar color="primary" class="d-flex site-toolbar">
  <div class="toolbar-logo-wrapper d-flex flex-column align-items-center">
    <a class="toolbar-logo" [routerLink]="['/']" data-automation-id="navigation_202110142420">
      <span class="visually-hidden">ONBOARD Logo - Navigate to Home</span>
    </a>
    <a
      class="simple-nav-link sr-only--focusable"
      [href]="[this.currentRoute + '#maincontent']"
      *ngIf="showInAppItems && !onLoginOrLogoutScreen"
      data-automation-id="navigation_202127112014"
    >
      Skip to Content
    </a>
  </div>

  <div
    class="toolbar-nav-wrapper d-flex align-items-center"
    *ngIf="showInAppItems && !onLoginOrLogoutScreen"
  >
    <a
      mat-button
      class="mat-nav-link-button"
      data-automation-id="navigation_202110142425"
      [routerLink]="[AppUrls.home()]"
      routerLinkActive="selected"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      My Dashboard
    </a>

    <a
      mat-button
      class="mat-nav-link-button"
      data-automation-id="navigation_202110142430"
      [routerLink]="[AppUrls.recentDownloads()]"
      routerLinkActive="selected"
      [routerLinkActiveOptions]="{ exact: true }"
      *ngIf="showAccount"
    >
      My Downloads
    </a>
  </div>

  <div
    class="toolbar-utility-wrapper d-flex align-items-center"
    *ngIf="showInAppItems && !onLoginOrLogoutScreen"
  >
    <button
      mat-button
      [matMenuTriggerFor]="profileMenu"
      aria-label="My Profile menu"
      data-automation-id="navigation_202127112031"
    >
      My Profile
      <mat-icon>expand_more</mat-icon>
    </button>
    <mat-menu class="mat-menu-primary" #profileMenu="matMenu" xPosition="before">
      <a
        data-automation-id="navigation_202110142509"
        mat-menu-item
        [routerLink]="[AppUrls.userProfile()]"
        *ngIf="showAccount"
      >
        My Account
      </a>

      <a
        data-automation-id="navigation_202110142513"
        mat-menu-item
        [routerLink]="[AppUrls.groups.myGroups()]"
        *ngIf="showAccount"
      >
        My Organizations
      </a>

      <a
        data-automation-id="navigation_202110142528"
        mat-menu-item
        [routerLink]="['/logout']"
        [queryParams]="{ doLogout: true, force: true }"
      >
        Log Out
      </a>
    </mat-menu>

    <ng-container *ngIf="showSubmitRequest">
      <button
        data-automation-id="navigation_202103100440"
        mat-flat-button
        color="tertiary"
        [matMenuTriggerFor]="requestMenu"
        aria-label="Submit a Request menu"
      >
        Submit a Request
        <mat-icon>expand_more</mat-icon>
      </button>
      <mat-menu class="mat-menu-tertiary" #requestMenu="matMenu" xPosition="before">
        <a
          data-automation-id="navigation_202103100417"
          mat-menu-item
          *ngIf="showNewPriorAuth"
          [routerLink]="AppUrls.filings.priorAuthRequest.create()"
        >
          Prior Authorization (PAR)
        </a>

        <a
          data-automation-id="navigation_202103100422"
          mat-menu-item
          *ngIf="showNewHp1"
          [routerLink]="AppUrls.filings.medicalBillingDispute.create()"
        >
          Decision on Unpaid Medical Bill (HP-1.0)
        </a>
      </mat-menu>
    </ng-container>
  </div>

  <div class="toolbar-link-wrapper d-flex align-items-center">
    <a
      data-automation-id="navigation_202110142612"
      mat-button
      href="https://www.wcb.ny.gov/MedPortal/"
      target="_blank"
    >
      Medical Portal
      <mat-icon class="toolbar-utility-icon" iconPositionEnd>open_in_new</mat-icon>
      <span class="visually-hidden">(Link opens in a new window)</span>
    </a>
  </div>
</mat-toolbar>

<mat-progress-bar
  *ngIf="httpInProgress$ | async"
  color="accent"
  mode="indeterminate"
></mat-progress-bar>
